<template>
  <div class="input-group" :class="`input-group-${variant} ${getStatus(error, success)}`">
    <label v-if="label !== ''" :for="id">{{ label }}</label>
    <select :id="id" v-model="modelValueHandler" class="form-control" :class="getClasses(size)" :name="name"
      :required="isRequired" :disabled="disabled">
      <option disabled value="">
        -- {{ defaultOptionLabel }} --
      </option>
      <option v-for="(item, index) in options" :key="index" :value="item[valueKey]">
        {{ item[labelKey] }}
      </option>
    </select>
  </div>
</template>

<script>
import { createVModelHandlers } from "@/helpers/vue";

export default {
  name: "MaterialSelect",
  props: {
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: "",
    },
    variant: {
      type: String,
      default: "outline",
    },
    size: {
      type: String,
      default: "default",
    },
    success: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: "",
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      default: () => [],
    },
    valueKey: {
      type: String,
      default: "id",
    },
    labelKey: {
      type: String,
      default: "name",
    },
    modelValue: {
      type: [String, Number],
      default: "",
    },
    defaultOptionLabel: {
      type: [String],
      default: "Selecteer een optie"
    }
  },

  emits: ["update:modelValue"],

  computed: {
    ...createVModelHandlers("modelValue"),
  },

  methods: {
    getClasses(size) {
      return size ? `form-control-${size}` : "";
    },
    getStatus(error, success) {
      if (success) return "is-valid";
      if (error) return "is-invalid";
      return "";
    },
  },
};
</script>
